export default "__VITE_ASSET__DGJm6KkQ__"